var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacilityKitchen = function SvgFacilityKitchen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160-160v-340H80v-60h150q-28.875 0-49.438-20.562Q160-601.125 160-630v-170h230v170q0 28.875-20.562 49.438Q348.875-560 320-560h360v-130q0-21.25-14.325-35.625T630.175-740 594.5-725 581-690h-61q1-46 32.912-78t77.5-32T708-767.917 740-690v130h140v60h-80v340zm60-460h110v-120H220zm0 400h230v-280H220zm290 0h230v-280H510zM220-620h110zm0 400h520z"
  })));
};
export default SvgFacilityKitchen;